import React, { Component } from 'react';

class Home extends Component {

	homeBlock() {
				
		return(
			
			<div className="home">
			
			<div className="dt-bk-color-dark dt-text-color-lightpink ">
			
				<h1 className="font-weight-light">Home</h1>
			
		      	<div className="container dt-container ">
		        	<div className="row align-items-center">
		        		        
		          <div className="col-lg-6 col-sm-12">
		            <p className="dt-text-large">
		            Discover Lasting Happiness with Diane Taylor Therapy
		            </p>
		            <p>
		            I specialize in working with individuals, couples, 
		            and families to improve communication, resolve conflict,
		            manage trauma and foster emotional well-being. My approach is compassionate, 
		            practical, and tailored to your unique needs. Together, we’ll 
		            work toward helping you feel more confident, connected, and grounded.
		            </p>  
		             
		          </div>
		          	          
		          <div className="col-lg-6 col-sm-12">
		            <img
		              className="sj-img img-fluid rounded mb-4 mb-lg-0"
		              src={global.config.imgs.banner1}
		              alt=""
		            />
		          </div>     	   
		          
		        </div>
		        
		        <br />
		        <div className="form-group text-center">
					<a href="/learn" className="dt-btn dt-btn-primary">Learn More</a>
				</div>
		        
		      </div>	
		     
		   <br />
		   <br /> 
		   </div>  
		    
		    <div className="container dt-container ">           	
	          	<div className="row align-items-center my-5">
		          	<div className="col-lg-12 col-sm-12">
			           
			           	<h2>Therapy Services</h2>
	
						<p>
						Providing personalized counseling for individuals, 
						couples, and families in Louisville, KY.
						</p>
		          	</div>			
		          	
		          	<div className="col-lg-3 col-md-6 col-sm-12 text-center">	
		          		<div className="dt-box-spacer">
			          		<div className="dt-box d-flex justify-content-center" >	          			          	
				          		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#bd88ae" class="bi bi-people" viewBox="0 0 16 16">
		  							<path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
								</svg>
							</div>
							<span>Emphasis on Relationships</span>
						</div>
					</div>   
					
					<div className="col-lg-3 col-md-6 col-sm-12 text-center">
						<div className="dt-box-spacer">
			          		<div className="dt-box d-flex justify-content-center" >	          			          	
				          		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#bd88ae" class="bi bi-chat-left-text" viewBox="0 0 16 16">
								  <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
								  <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
								</svg>
							</div>
							<span>Effective Communication</span>
						</div>
					</div>  
					
					<div className="col-lg-3 col-md-6 col-sm-12 text-center">
						<div className="dt-box-spacer">
			          		<div className="dt-box d-flex justify-content-center" >	          			          	
				          		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#bd88ae" class="bi bi-hearts" viewBox="0 0 16 16">
								  <path fill-rule="evenodd" d="M4.931.481c1.627-1.671 5.692 1.254 0 5.015-5.692-3.76-1.626-6.686 0-5.015m6.84 1.794c1.084-1.114 3.795.836 0 3.343-3.795-2.507-1.084-4.457 0-3.343M7.84 7.642c2.71-2.786 9.486 2.09 0 8.358-9.487-6.268-2.71-11.144 0-8.358"/>
								</svg>
							</div>
							<span>Holistic Approach to Healing</span>
						</div>
					</div>					
					
					<div className="col-lg-3 col-md-6 col-sm-12 text-center">
						<div className="dt-box-spacer">	
			          		<div className="dt-box d-flex justify-content-center" >	          			          	
				          		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#bd88ae" class="bi bi-arrow-down-circle" viewBox="0 0 16 16">
	  								<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
								</svg>
							</div>
							<span>Supportive Guidance for Personal Growth</span>
						</div>
					</div>						
							          	
			  	</div>
			
				<div className="col-lg-12">
	          		<hr />
	          	</div> 	
	
	        </div>
		    
		    <div className="dt-bk-color-light">  	
		    	<div className="container dt-container ">  
		    	
		    	<br/>
		    	<br/>
		    	
		      		<div className="row align-items-center my-5">
		      	
			      		<div className="col-lg-6 col-sm-12">
			      			<div className="dt-box-spacer">		      	
			      			Ready to start your journey towards a healthier, happier life?
			      			</div>
			      		</div>
			      		
			      		<div className="col-lg-6 col-sm-12 text-center">
			      			<div className="dt-box-spacer">	
			      				<a href="/contact" className="dt-btn dt-btn-primary">Contact</a>
			      			</div>
			      		</div>
			      	</div>
		      	
		      	<br/>
		      	<br/>
		      	
		      	</div>
		    </div>  
		      	        
		   </div>
		      
		);
			
	}

    render() {

		document.title = global.config.pageTitles.title;	

		return this.homeBlock()

    }

}

export default Home;


